import { HttpContextToken } from '@angular/common/http';

export const SUPPRESS_ACCESS_DENIED_ALERT = new HttpContextToken<boolean>(() => false);
